import { render, staticRenderFns } from "./CustomerAssignment.vue?vue&type=template&id=670e8a34&"
import script from "./CustomerAssignment.vue?vue&type=script&lang=js&"
export * from "./CustomerAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports